import { getAuth, getIdToken } from "firebase/auth";

const API_BASE = "https://europe-west3-hyper-e122e.cloudfunctions.net";

class SubscriptionsService {
  /**
   * Получение списка подписанных компаний
   * @returns {Promise<Array>} массив компаний
   */
  async getSubscribedCompanies() {
    try {
      const auth =
        getAuth();
  
      await auth.authStateReady();
  
      const user =
        auth.currentUser;
  
      if (!user) {
        console.warn(
          "❌ Пользователь не авторизован → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return [];
      }
  
      const token =
        await getIdToken(
          user
        );
  
      const userId =
        user.uid;
  
      const url =
        `${API_BASE}/get_subscribed_companies?user_id=${userId}`;
  
      const response =
        await fetch(
          url,
          {
            method: "GET",
  
            headers: {
              Authorization:
                `Bearer ${token}`,
            },
          }
        );
  
      /*
       * Токен протух / backend не принимает сессию
       */
      if (
        response.status === 401
      ) {
        console.warn(
          "❌ Сессия недействительна → редирект на стартовую"
        );
  
        window.location.replace(
          "https://hr3.space/"
        );
  
        return [];
      }
  
      const result =
        await response.json();
  
      if (!response.ok) {
        throw new Error(
          result.error ||
          "Ошибка при получении подписок"
        );
      }
  
      return (
        result.companies ||
        []
      );
  
    } catch (error) {
      console.error(
        "❌ Ошибка в SubscriptionsService:",
        error
      );
  
      throw error;
    }
  }

  /**
   * Отписка от компании
   * @param {string} companyId — ID компании
   * @returns {Promise<boolean>} — успех/ошибка
   */
  async unsubscribeFromCompany(companyId) {
    try {
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) throw new Error("Пользователь не авторизован");

      const token = await getIdToken(user, true);
      const userId = user.uid;

      const response = await fetch(`${API_BASE}/unfollow_company`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          user_id: userId,
          company_id: companyId,
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || "Ошибка при отписке от компании");
      }

      return result.status === "success";
    } catch (error) {
      console.error("❌ Ошибка отписки:", error);
      throw error;
    }
  }
}

export default new SubscriptionsService();